import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import LoginView from './LoginView';
import { actions } from './actions';

function mapStateToProps(state) {
  return {
    login: state.login,
    redirectTo: state.auth.redirectTo
  };
}

function mapDispatchToProps(dispatch) {
  return {
    postLogin: (code, protocol, hostname) => dispatch(actions.postLogin(code, protocol, hostname)),
    clearLoginStatus: () => dispatch(actions.clearLoginStatus()),
    checkUserPrivileges: () => dispatch(actions.checkUserPrivileges()),
    fetchExternalSignInParameters: () => dispatch(actions.fetchExternalSignInParameters()),
    clockIn: () => dispatch(actions.clockIn())
  };
}

const loginViewContainer = injectIntl(connect(mapStateToProps, mapDispatchToProps)(LoginView));

const route = {
  path: '/login',
  component: loginViewContainer
};

export default loginViewContainer;
export { route, mapStateToProps, mapDispatchToProps, loginViewContainer as Login };